import { render, staticRenderFns } from "./RolesBox.vue?vue&type=template&id=14ae605b"
import script from "./RolesBox.vue?vue&type=script&lang=js"
export * from "./RolesBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports